import { Selector } from '@ngxs/store';
import { VoiceSubscriptionOffering } from '../../modules/subscription/models/offerings-response.model';
import { OfferingState, OfferingStateModel } from './offering.state';
import { BindingType } from '@app/shared/models/subscription-offering.model';

const hasHandsetBinding = (offering: VoiceSubscriptionOffering): boolean =>
  !!offering.bindings?.some(binding => binding.bindingType === BindingType.Handset);

export class OfferingSelectors {
  @Selector([OfferingState])
  public static getAllOfferings(state: OfferingStateModel): VoiceSubscriptionOffering[] {
    return state.products;
  }

  @Selector([OfferingState])
  public static getAvailableForChangeOfferings(state: OfferingStateModel): VoiceSubscriptionOffering[] {
    return state.availableForChangeOfferings ?? [];
  }

  @Selector([OfferingSelectors.getAllOfferings, OfferingSelectors.getAvailableForChangeOfferings])
  public static getManualRegistrationOfferings(
    dealerOfferings: VoiceSubscriptionOffering[],
    availableForChangeOfferings: VoiceSubscriptionOffering[]
  ): VoiceSubscriptionOffering[] {
    const dealerOfferingIds = new Set(dealerOfferings.map(offering => offering.id));
    const belowTheLineOfferings = availableForChangeOfferings.filter(offering => !dealerOfferingIds.has(offering.id));

    return [...dealerOfferings, ...belowTheLineOfferings].filter(hasHandsetBinding);
  }

  @Selector([OfferingState])
  public static isLoadingAdditionalServicesForOffering(state: OfferingStateModel): boolean {
    return state.isLoadingAdditionalServiceOfferings;
  }

  @Selector([OfferingState])
  public static loadingAdditionalServicesForOfferingId(state: OfferingStateModel): string {
    return state.loadingAdditionalServiceForOfferingId;
  }
}
